module.exports = __webpack_public_path__ + "img/1527030020.cb1ac0c8.jpg";